// import axios from "axios"
// import { post, del, get, put } from "./api_helper"
// import * as url from "./url_helper"
// import { toast } from "react-toastify";


// export const fetchAdminDashboardData = () => get(url.GET_ADMIN_DASHBOARD_DATA);
// export const fetchTrainerDashboardData = () => get(url.GET_TRAINER_DASHBOARD_DATA);
// export const fetchContentManagerDashboardData = () => get(url.GET_CONTENT_MANAGER_DASHBOARD_DATA);

// export const getTataDashboardData = () => get(url.GET_TATA_DASHBOARD_DATA);






import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"
import { toast } from "react-toastify";

export const fetchAdminDashboardData = () => get(url.GET_ADMIN_DASHBOARD_DATA);
export const fetchTrainerDashboardData = () => get(url.GET_TRAINER_DASHBOARD_DATA);
export const fetchContentManagerDashboardData = () => get(url.GET_CONTENT_MANAGER_DASHBOARD_DATA);

// Updated getTataDashboardData with all filter parameters
export const getTataDashboardData = async (division = '', state = '', depot = '') => {
  try {
    let apiUrl = url.GET_TATA_DASHBOARD_DATA;
    const params = new URLSearchParams();
    
    if (division) params.append('division', division);
    if (state) params.append('state', state);
    if (depot) params.append('depot', depot); // Add depot filter
    
    if (params.toString()) {
      apiUrl += `?${params.toString()}`;
    }
    
    console.log(`Fetching Tata dashboard data with filters:`, { division, state, depot });
    const response = await get(apiUrl);
    return response;
  } catch (error) {
    console.error("Error fetching Tata dashboard data:", error);
    toast.error("Failed to fetch dashboard data");
    throw error;
  }
};

// Fetch depot list from backend
export const fetchDepotList = async () => {
  try {
    const response = await get(url.GET_ALL_DEPOTS);
    return response;
  } catch (error) {
    console.error("Error fetching depot list:", error);
    // Return empty array if endpoint doesn't exist yet
    return { success: false, data: [] };
  }
};

// Fetch state list from backend
export const fetchStateList = async () => {
  try {
    const response = await get(url.GET_ALL_STATES);
    return response;
  } catch (error) {
    console.error("Error fetching state list:", error);
    return { success: false, data: [] };
  }
};

// Fetch division list from backend
export const fetchDivisionList = async () => {
  try {
    const response = await get(url.GET_ALL_DIVISIONS);
    return response;
  } catch (error) {
    console.error("Error fetching division list:", error);
    return { success: false, data: [] };
  }
};